import {BaseService} from "./base.service";

class SupplierAmbulancesService extends BaseService {

    constructor() {
        super('api/ambulances')
    }
}

export const supplierambulancesService = new SupplierAmbulancesService();
